export default function deleteCookie(name: string) {
	const cookieString = `${name}=; Max-Age=0; Path=/;`;
	document.cookie = cookieString;
}
